import { DetailsControlType } from 'shared/details-page/details-control/details-control-type';


export const collapseWidth = 60;
export const collapseWidthPx = `${collapseWidth}px`;
export const dimColWidth = 101;
export const titleColWidth = `calc(100% - ${dimColWidth * 4 + collapseWidth}px)`;

export const rowData: Array<any> = [
  {
    fieldName: 'packageUomTitle',
    width: titleColWidth,
    type: DetailsControlType.Select,
  }, {
    fieldName: 'dimensionsLength',
    width: `${dimColWidth}px`,
  }, {
    fieldName: 'dimensionsWidth',
    width: `${dimColWidth}px`,
  }, {
    fieldName: 'dimensionsHeight',
    width: `${dimColWidth}px`,
  }, {
    fieldName: 'weight',
    width: `${dimColWidth}px`,
  },
];

export const detailsData: Array<any> = [
  // line
  {
    cols: [{
      fieldName: 'dimensionalWeight',
      width: '25%',
    }, {
      fieldName: 'weightVariance',
      width: '75%',
    }],
  },
  // line
  {
    cols: [{
      fieldName: 'packageLevelGtin',
      width: '25%',
    }, {
      fieldName: 'packageBarCodeCharacters',
      width: '25%',
    }, {
      fieldName: 'electronicProductCode',
      width: '25%',
    }, {
      fieldName: 'stackingFactor',
      width: '25%',
    }],
    isNoMarginBottom: true,
  },
  // third line
  {
    cols: [{
      fieldName: 'innerQuantity',
      width: '25%',
      combined: ['innerQuantity', 'innerQuantityUom'],
    }, {
      fieldName: 'quantity',
      width: '25%',
    }, {
      fieldName: 'orderable',
      width: '25%',
      type: DetailsControlType.Select,
    }],
  },
  // shipping line
  {
    cols: [
      {
        fieldName: 'shippingLength',
        width: '25%',
      },
      {
        fieldName: 'shippingWidth',
        width: '25%',
      },
      {
        fieldName: 'shippingHeight',
        width: '25%',
      },
    ],
  },
];

export const detailsShippingData: Array<any> = [

];

export const hazardousData: Array<any> = [
  // line
  {
    cols: [{
      fieldName: 'languageCode',
      width: '100%',
      type: DetailsControlType.Select,
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'shippingScope',
      width: '25%',
      type: DetailsControlType.Select,
    }, {
      fieldName: 'bulk',
      width: '25%',
      type: DetailsControlType.Select,
    }, {
      fieldName: 'regulatingCountry',
      width: '25%',
      type: DetailsControlType.Select,
    }, {
      fieldName: 'transportMethod',
      width: '25%',
      type: DetailsControlType.Select,
    }],
  },
  // line
  {
    cols: [{
      fieldName: 'regulated',
      width: '100%',
      type: DetailsControlType.Select,
    }],
  },
  // line
  {
    cols: [{
      fieldName: 'description',
      width: '100%',
      type: DetailsControlType.Textarea,
    }],
  },
  // line
  {
    cols: [{
      fieldName: 'hazardousMaterialCodeQualifier',
      width: '50%',
      type: DetailsControlType.Select,
    }, {
      fieldName: 'hazardousMaterialClassCode',
      width: '50%',
      type: DetailsControlType.Select,
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'hazardousMaterialDescription',
      width: '100%',
      type: DetailsControlType.Textarea,
    }],
  },
  // line
  {
    cols: [{
      fieldName: 'whmisCode',
      width: '100%',
      type: DetailsControlType.Select,
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'whmisFreeText',
      width: '100%',
      type: DetailsControlType.Textarea,
    }],
  },
  // line
  {
    cols: [{
      fieldName: 'hazardousClass',
      width: '25%',
    }, {
      fieldName: 'outerPackageLabel',
      width: '25%',
    }, {
      fieldName: 'shippingName',
      width: '25%',
    }, {
      fieldName: 'unnaidCode',
      width: '25%',
    }],
    isNoMarginBottom: true,
  },
];

export const packingData: Array<any> = [
  // line
  {
    cols: [{
      fieldName: 'packingGroupCode',
      width: '50%',
      type: DetailsControlType.Select,
    }, {
      fieldName: 'regulationsExemptionCode',
      width: '50%',
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'hazardousPlacardNotation',
      width: '100%',
      type: DetailsControlType.Textarea,
    }],
    isNoMarginBottom: true,
  },
  // line
  {
    cols: [{
      fieldName: 'textMessage',
      width: '100%',
      type: DetailsControlType.Textarea,
    }],
  },
];
